import * as React from 'react';

import {Button} from '@deviceinsight/ng-ui-basic-components';

import {Trans} from '@deviceinsight/ng-ui-scale-lib/api';
import assetIcon from '../../../../../assets/icon_asset.svg';

type Props = {
	assetName: string | null | undefined;
	selectAsset: () => void;
	'data-testid'?: string;
};

const SelectAssetButton = ({assetName, selectAsset, ...rest}: Props) => {
	const textAlign = assetName ? 'left' : 'center';
	const label = assetName ? (
		<span title={assetName}>{assetName}</span>
	) : (
		<Trans i18nKey="dashboard.widgets.config.selectAsset">Select Asset</Trans>
	);
	return (
		<Button
			{...rest}
			onClick={selectAsset}
			title={
				assetName
					? assetName
					: {
							id: 'dashboard.widgets.config.selectAsset',
							defaultValue: 'Select Asset'
					  }
			}
			style={{
				textAlign
			}}
			className={assetName ? 'datasource-button' : ''}>
			{assetName && <img src={assetIcon} alt="asset" className="datasource-icon" />}
			{label}
		</Button>
	);
};

export default SelectAssetButton;
